import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import moment from "moment";

// Login Redux States
import { LOGIN_USER, LOGOUT_USER, SOCIAL_LOGIN } from "./actionTypes";
import { apiError, loginSuccess, logoutUserSuccess } from "./actions";

//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper";
import { login, logout } from "../../../helpers/auth_helper";

const fireBaseBackend = getFirebaseBackend();

// Bongasoft tokens: accessToken / refreshToken / expiresIn (milliseconds).
const setToken = (data) => {
  localStorage.setItem('sessionToken', data.accessToken);
  localStorage.setItem('refreshToken', data.refreshToken);
  localStorage.setItem('expiredTime', moment().add(data.expiresIn, 'millisecond'));
  return true;
}

function* loginUser({ payload: { user, history } }) {
  try {
    const response = yield call(login, {
      email: user.email,
      password: user.password,
    });
    setToken(response);
    yield put(loginSuccess(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* logoutUser({ payload: { history } }) {
  try {
    const token = localStorage.getItem('sessionToken');
    const refreshToken = localStorage.getItem('refreshToken');
    // Best-effort server-side logout; never block the local clear on it.
    if (token) {
      try { yield call(logout, token, refreshToken); } catch (e) { /* ignore */ }
    }
    localStorage.removeItem("authUser");
    localStorage.removeItem('sessionToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('expiredTime');

    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const response = yield call(fireBaseBackend.logout);
      yield put(logoutUserSuccess(response));
    }
    if (typeof history === 'function') history('/login');
  } catch (error) {
    yield put(apiError(error));
  }
}

function* socialLogin({ payload: { type, history } }) {
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const fireBaseBackend = getFirebaseBackend();
      const response = yield call(fireBaseBackend.socialLoginUser, type);
      if (response) {
        history("/dashboard");
      } else {
        history("/login");
      }
      localStorage.setItem("authUser", JSON.stringify(response));
      yield put(loginSuccess(response));
    }
    if (response)
      history("/dashboard");
  } catch (error) {
    yield put(apiError(error));
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser);
  yield takeLatest(SOCIAL_LOGIN, socialLogin);
  yield takeEvery(LOGOUT_USER, logoutUser);
}

export default authSaga;
